var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H108C113.523 0 118 4.47715 118 10V114H0V10Z",
  fill: "#FF7045",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58 87C75.6731 87 90 72.6731 90 55C90 37.3269 75.6731 23 58 23C40.3269 23 26 37.3269 26 55C26 72.6731 40.3269 87 58 87Z",
  fill: "#FF7045"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.2437 71.0657L60.1095 86.9316C76.7994 85.8456 90.0003 71.9644 90.0003 55.0001C90.0003 54.1106 89.9639 53.2294 89.8928 52.3583L71.7563 34.2217L44.2437 71.0657Z",
  fill: "#DE4726"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.2363 72.0763H46.7636C44.7467 72.0763 43.1116 70.4413 43.1116 68.4243V36.8639C43.1116 34.847 44.7466 33.2119 46.7636 33.2119H69.2362C71.2531 33.2119 72.8882 34.8469 72.8882 36.8639V68.4243C72.8882 70.4413 71.2532 72.0763 69.2363 72.0763Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.2364 33.2119H58V72.0763H69.2364C71.2532 72.0763 72.8884 70.4413 72.8884 68.4243V36.8638C72.8882 34.8469 71.2532 33.2119 69.2364 33.2119Z",
  fill: "#E9EDF5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3198 37.6875H68.68V52.259H47.3198V37.6875Z",
  fill: "#64E1DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 37.6875H68.68V52.259H58V37.6875Z",
  fill: "#1CADB5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.7927 63.0117H65.2075V72.0765H50.7927V63.0117Z",
  fill: "#636978"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 63.0117H65.2074V72.0765H58V63.0117Z",
  fill: "#414952"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0576 68.0781H61.9422V80.2569H54.0576V68.0781Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 68.0781H61.9424V80.2569H58V68.0781Z",
  fill: "#E9EDF5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.0576 65.3779H61.9424V69.3623H54.0576V65.3779Z",
  fill: "#FF936B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 65.3779H61.9424V69.3623H58V65.3779Z",
  fill: "#FF7045"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.6211 59.4461C50.892 59.4461 51.9223 58.4032 51.9223 57.1166C51.9223 55.8301 50.892 54.7871 49.6211 54.7871C48.3501 54.7871 47.3198 55.8301 47.3198 57.1166C47.3198 58.4032 48.3501 59.4461 49.6211 59.4461Z",
  fill: "#AFB4C8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.3786 59.4461C67.6496 59.4461 68.6799 58.4032 68.6799 57.1166C68.6799 55.8301 67.6496 54.7871 66.3786 54.7871C65.1077 54.7871 64.0774 55.8301 64.0774 57.1166C64.0774 58.4032 65.1077 59.4461 66.3786 59.4461Z",
  fill: "#7E8596"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.0002 59.4461C59.2712 59.4461 60.3015 58.4032 60.3015 57.1166C60.3015 55.8301 59.2712 54.7871 58.0002 54.7871C56.7293 54.7871 55.699 55.8301 55.699 57.1166C55.699 58.4032 56.7293 59.4461 58.0002 59.4461Z",
  fill: "#AFB4C8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 54.7871V59.4462C59.271 59.4462 60.3013 58.4032 60.3013 57.1167C60.3013 55.8302 59.271 54.7871 58 54.7871Z",
  fill: "#7E8596"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.5815 46.6611C61.5815 48.6634 59.9779 50.2868 57.9997 50.2868C56.0216 50.2868 54.418 48.6636 54.418 46.6611C54.418 44.6586 57.9997 39.6592 57.9997 39.6592C57.9997 39.6592 61.5815 44.6587 61.5815 46.6611Z",
  fill: "#FF7045"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58 39.6592V50.2868C59.9781 50.2868 61.5817 48.6636 61.5817 46.6611C61.5817 44.6586 58 39.6592 58 39.6592Z",
  fill: "#DE4726"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white",
  transform: "translate(26 23)"
})));
function SvgSymptomDiabetes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomDiabetes);
export default __webpack_public_path__ + "static/media/symptom-Diabetes.e5eccd84018a25252f4cf14b108f917f.svg";
export { ForwardRef as ReactComponent };